import { Component, Input } from '@angular/core';
import { KpiRow } from '../../marketing-dashboard.models';

@Component({
	selector: 'app-kpi-snapshot',
	templateUrl: './kpi-snapshot.component.html',
	styleUrls: ['./kpi-snapshot.component.scss'],
	standalone: false
})
export class KpiSnapshotComponent {

	@Input() kpis: KpiRow[] = [];

	formatLabel(name: string): string {
		return name
			.split('_')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	}

	formatValue(kpi: KpiRow): string {
		if (kpi.value === null) {
			return 'Pending (external)';
		}
		switch (kpi.name) {
			case 'direct_booking_rate':
			case 'activity_attach_rate':
			case 'repeat_guest_rate':
			case 'listing_completeness_pct':
				return kpi.value.toFixed(1) + '%';
			case 'email_open_rate':
			case 're_engagement_rate':
				return kpi.value.toFixed(1) + '%';
			case 'avg_review_score':
				return kpi.value.toFixed(2);
			case 'ta_bookings_count':
				return Math.round(kpi.value).toString();
			case 'roas':
				return kpi.value.toFixed(1) + 'x';
			default:
				return kpi.value.toFixed(1);
		}
	}

	formatTarget(kpi: KpiRow): string {
		if (kpi.target === null) {
			return '';
		}
		switch (kpi.name) {
			case 'direct_booking_rate':
			case 'activity_attach_rate':
			case 'repeat_guest_rate':
			case 'listing_completeness_pct':
			case 'email_open_rate':
			case 're_engagement_rate':
				return 'Target: ' + kpi.target.toFixed(1) + '%';
			case 'avg_review_score':
				return 'Target: ' + kpi.target.toFixed(2);
			case 'ta_bookings_count':
				return 'Target: ' + Math.round(kpi.target).toString();
			case 'roas':
				return 'Target: ' + kpi.target.toFixed(1) + 'x';
			default:
				return 'Target: ' + kpi.target.toFixed(1);
		}
	}

	tagSeverity(status: string): string {
		switch (status) {
			case 'green': return 'success';
			case 'yellow': return 'warning';
			case 'red': return 'danger';
			default: return null;
		}
	}

	tagLabel(status: string): string {
		switch (status) {
			case 'green': return 'On Track';
			case 'yellow': return 'At Risk';
			case 'red': return 'Off Track';
			default: return 'No Data';
		}
	}
}
